// extracted by mini-css-extract-plugin
module.exports = {"cardtopair":"cardtopair--YR4Qd","initialized":"initialized--qgzaO"};